import React, { createContext } from 'react';

// --- 1. FIX: Create and export CartContext here ---
export const CartContext = createContext();

// --- 2. FIX: Define and export initialState here ---
export const initialState = []; // An empty array to hold cart items

// Step 3: Create a reducer function to handle cart actions
// (This is the "dumb" reducer with no logic or alerts)
// Step 3: Create a reducer function to handle cart actions
export const cartReducer = (state, action) => {

  // NOTE: All 'alert()' and stock logic has been REMOVED.

  switch (action.type) {
    case 'ADD_ITEM': {
      const itemToAdd = action.payload;
      const existingItem = state.find((item) => item.id === itemToAdd.id);

      if (existingItem) {
        // If it exists, update the quantity
        return state.map((item) =>
          item.id === itemToAdd.id
            ? { ...item, quantity: existingItem.quantity + itemToAdd.quantity }
            : item
        );
      } else {
        // If it doesn't exist, add it to the cart
        return [...state, { ...itemToAdd }];
      }
    }

    case 'REMOVE_ITEM':
      // Remove the item from the cart
      return state.filter((item) => item.id !== action.payload.id);

    case 'UPDATE_QUANTITY': {
      // Update the quantity of a specific item
      return state.map((item) =>
        item.id === action.payload.id
          ? { ...item, quantity: action.payload.quantity }
          : item
      );
    }

    case 'CLEAR_CART':
      // Clear the entire cart
      return [];

    default:
      return state;
  }
};
